import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import BlogList from './BlogList';

export const posts = [
  {
    date: 'November 20, 2025',
    category: 'Artificial Intelligence',
    title: 'The Future of AI in Enterprise: Trends to Watch in 2026',
    excerpt: 'Explore the emerging AI trends that will reshape how businesses operate, from advanced automation to ethical AI frameworks.',
    image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80',
    readTime: '8 min read',
    author: 'Dr. Sarah Mitchell',
    slug: 'future-ai-enterprise-2026'
  },
  {
    date: '11 December 2025',
    category: 'CRM & AI',
    title: 'Salesforce CRM & AI: Driving Customer Success',
    excerpt: 'Learn how Salesforce CRM and AI are transforming customer success strategies for the future.',
    image: 'https://images.unsplash.com/photo-1510511459019-5dda7724fd87?auto=format&fit=crop&w=800&q=80',
    readTime: '6 min read',
    author: 'CRM Solutions Team',
    slug: 'salesforce-crm-ai-customer-success'
  },
  {
    date: 'November 15, 2025',
    category: 'Data Science',
    title: 'Building Scalable Data Pipelines with Modern Architecture',
    excerpt: 'Learn how to design and implement data pipelines that can handle millions of records while maintaining performance and reliability.',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80',
    readTime: '10 min read',
    author: 'James Chen',
    slug: 'scalable-data-pipelines'
  },
  {
    date: 'November 10, 2025',
    category: 'Cloud Computing',
    title: 'Multi-Cloud Strategy: Best Practices for 2025',
    excerpt: 'Discover how leading organizations are leveraging multiple cloud providers to optimize costs, improve resilience, and avoid vendor lock-in.',
    image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&q=80',
    readTime: '7 min read',
    author: 'Maria Rodriguez',
    slug: 'multi-cloud-strategy-2025'
  },
  {
    date: 'November 5, 2025',
    category: 'DevOps',
    title: 'GitOps and Infrastructure as Code: A Complete Guide',
    excerpt: 'Master the principles of GitOps and learn how to manage your infrastructure declaratively using modern IaC tools and practices.',
    image: 'https://images.unsplash.com/photo-1618401471353-b98afee0b2eb?w=800&q=80',
    readTime: '12 min read',
    author: 'Alex Kumar',
    slug: 'gitops-infrastructure-as-code'
  },
  {
    date: 'October 28, 2025',
    category: 'Business Intelligence',
    title: 'Real-Time Analytics: Transforming Decision Making',
    excerpt: 'How real-time data analytics is enabling businesses to make faster, more informed decisions and respond to market changes instantly.',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80',
    readTime: '6 min read',
    author: 'Emily Watson',
    slug: 'real-time-analytics-decision-making'
  },
  {
    date: 'October 20, 2025',
    category: 'AI Ethics',
    title: 'Responsible AI: Building Trust in Machine Learning Systems',
    excerpt: 'Explore the ethical considerations and frameworks necessary for developing AI systems that are fair, transparent, and accountable.',
    image: 'https://images.unsplash.com/photo-1535378620166-273708d44e4c?w=800&q=80',
    readTime: '9 min read',
    author: 'Dr. Michael Torres',
    slug: 'responsible-ai-trust-ml'
  },
  {
    date: 'October 14, 2025',
    category: 'MLOps',
    title: 'Top Data Warehouse Vendors in 2025',
    excerpt: 'A comprehensive comparison of leading data warehouse solutions, helping you choose the right platform for your organization\'s needs.',
    image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&q=80',
    readTime: '11 min read',
    author: 'Robert Lee',
    slug: 'top-data-warehouse-vendors-2025'
  },
  {
    date: 'October 7, 2025',
    category: 'Computer Vision',
    title: '10 Benefits of a Data Warehouse in Business',
    excerpt: 'Discover how implementing a modern data warehouse can revolutionize your business intelligence, reporting, and analytics capabilities.',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80',
    readTime: '8 min read',
    author: 'Linda Park',
    slug: '10-benefits-data-warehouse'
  },
  {
    date: 'September 30, 2025',
    category: 'Java & Spring Boot',
    title: 'Spring Boot 3.x: Building Enterprise Applications with Modern Java',
    excerpt: 'Explore the latest features in Spring Boot 3.x, including native compilation, observability improvements, and Jakarta EE 10 support for building high-performance enterprise applications.',
    image: 'https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=800&q=80',
    readTime: '10 min read',
    author: 'Rajesh Sharma',
    slug: 'spring-boot-3-enterprise-applications'
  },
  {
    date: 'September 22, 2025',
    category: 'Microservices',
    title: 'Microservices Architecture with Spring Cloud: A Practical Guide',
    excerpt: 'Learn how to design, build, and deploy scalable microservices using Spring Cloud, including service discovery, API gateway, and distributed tracing.',
    image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&q=80',
    readTime: '12 min read',
    author: 'Priya Patel',
    slug: 'microservices-spring-cloud-guide'
  },
  {
    date: 'September 15, 2025',
    category: 'Jakarta EE',
    title: 'Jakarta EE 10: The Evolution of Enterprise Java',
    excerpt: 'Discover the new features and improvements in Jakarta EE 10, from updated persistence APIs to enhanced security and cloud-native capabilities.',
    image: 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=800&q=80',
    readTime: '9 min read',
    author: 'Vikram Singh',
    slug: 'jakarta-ee-10-enterprise-java'
  },
  {
    date: 'September 8, 2025',
    category: 'Java Performance',
    title: 'Java Performance Optimization: JVM Tuning and Best Practices',
    excerpt: 'Master JVM tuning, garbage collection optimization, and performance profiling techniques to build high-throughput Java applications.',
    image: 'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=800&q=80',
    readTime: '11 min read',
    author: 'Amit Desai',
    slug: 'java-performance-jvm-tuning'
  },
  {
    date: 'August 30, 2025',
    category: 'Oracle HCM',
    title: 'Oracle PeopleSoft HCM: Modernizing Human Capital Management',
    excerpt: 'Discover how Oracle PeopleSoft HCM streamlines HR processes, from talent acquisition to workforce analytics, with cloud-ready architecture and AI-powered insights.',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80',
    readTime: '10 min read',
    author: 'Suresh Nair',
    slug: 'oracle-peoplesoft-hcm-modernization'
  },
  {
    date: 'August 22, 2025',
    category: 'Retail Technology',
    title: 'Oracle Xstore & Xadmin: Next-Gen Retail Point of Service Solutions',
    excerpt: 'Learn how Oracle Xstore POS and Xadmin management tools deliver seamless omnichannel retail experiences with real-time inventory, mobile POS, and advanced analytics.',
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&q=80',
    readTime: '9 min read',
    author: 'Neha Kapoor',
    slug: 'oracle-xstore-xadmin-retail-solutions'
  },
  {
    date: 'August 15, 2025',
    category: 'CRM Platforms',
    title: 'Salesforce CRM: Driving Customer Success with AI-Powered Insights',
    excerpt: 'Explore how Salesforce CRM transforms customer relationships through Einstein AI, comprehensive analytics, and seamless integration across sales, service, and marketing.',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80',
    readTime: '11 min read',
    author: 'Ananya Reddy',
    slug: 'salesforce-crm-ai-customer-success'
  },
  {
    date: 'August 8, 2025',
    category: 'BPM & CRM',
    title: 'Pega CRM: Intelligent Automation for Customer Engagement',
    excerpt: 'Understand how Pega CRM combines low-code development, AI-driven decisioning, and case management to deliver personalized customer experiences at scale.',
    image: 'https://images.unsplash.com/photo-1553877522-43269d4ea984?w=800&q=80',
    readTime: '10 min read',
    author: 'Karthik Iyer',
    slug: 'pega-crm-intelligent-automation'
  },
  {
    date: 'July 30, 2025',
    category: 'Digital Marketing',
    title: 'AI-Powered Digital Marketing: Transforming Customer Acquisition',
    excerpt: 'Discover how AI and machine learning are revolutionizing digital marketing strategies, from predictive analytics to personalized campaigns and automated optimization.',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80',
    readTime: '9 min read',
    author: 'Meera Krishnan',
    slug: 'ai-powered-digital-marketing'
  },
  {
    date: 'July 22, 2025',
    category: 'Digital Marketing',
    title: 'SEO & Content Marketing Strategies for 2025: A Data-Driven Approach',
    excerpt: 'Learn advanced SEO techniques, content optimization strategies, and how to leverage data analytics to drive organic traffic and improve conversion rates.',
    image: 'https://images.unsplash.com/photo-1432888622747-4eb9a8efeb07?w=800&q=80',
    readTime: '8 min read',
    author: 'Aditya Verma',
    slug: 'seo-content-marketing-strategies-2025'
  }
];

export default function Blog() {
  return (
    <Container sx={{ py: 6 }}>
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <Typography 
          variant="h3" 
          gutterBottom
          sx={{
            fontWeight: 700,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            mb: 2
          }}
        >
          Blog & Insights
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 800, mx: 'auto' }}>
          Stay informed with the latest trends, best practices, and insights from our team of experts in AI, data science, and cloud technologies.
        </Typography>
      </Box>
      <BlogList posts={posts} />
    </Container>
  );
}
